import React from "react";

import { ETargetSwitch } from "../organisms/TargetGroup";
import { objectArrayToKeyArray } from "../libs/Util";

export const useTargetGroupUpdate = (
  state: any,
  setState: React.Dispatch<React.SetStateAction<any>>,
  options: {
    defaultTargetSwitch?: ETargetSwitch | "BOX";
    realization?: any;
  } = {},
) => {
  const { defaultTargetSwitch, realization } = options;

  const handleTargetGroupUpdate = React.useCallback(
    (args: any) => {
      if (
        args.targetSwitch !== undefined &&
        args.targetSwitch !== state.targetSwitch
      ) {
        const newSwitch = args.targetSwitch;
        const restoredParams: any = {
          selected_box_id: null,
          selected_teacher_ids: [],
          selected_class_ids: [],
          isBoxToggleOn: false,
        };

        if (newSwitch === defaultTargetSwitch && realization) {
          if (
            newSwitch === ETargetSwitch.TEACHER &&
            realization.submitted_teachers
          ) {
            restoredParams.selected_teacher_ids = objectArrayToKeyArray(
              realization.submitted_teachers,
            );
          }
          if (newSwitch === ETargetSwitch.GROUP && realization.shared_classes) {
            restoredParams.selected_class_ids = objectArrayToKeyArray(
              realization.shared_classes,
            );
          }
        }
        setState((prevState: any) => ({
          ...prevState,
          ...args,
          ...restoredParams,
        }));
      } else {
        setState((prevState: any) => ({ ...prevState, ...args }));
      }
    },
    [defaultTargetSwitch, realization, state.targetSwitch, setState],
  );

  return { handleTargetGroupUpdate };
};
